import Vue from 'vue';
import Helpers from '@/tools/Helpers'

const BASE_URL = '/api';

const state = {
    userData: {},
    currentWeek: 0,
    ratingList: [],
    userRatingList: [],
    winners: [],
};

const actions = {

    getUser({dispatch, commit, getters, rootGetters}) {
        return new Promise((resolve, reject) => {
            Vue.http.get(rootGetters['GET_URL_ROOT'] + BASE_URL + '/user').then(
                (response) => {
                    commit('updateUserData', response.body);
                    resolve();
                },
                () => {
                    commit('clearAllData');
                    reject();
                })
        })
    },

    getCurrentWeek({dispatch, commit, getters, rootGetters}) {
        return new Promise((resolve, reject) => {
            Vue.http.get(rootGetters['GET_URL_ROOT'] + BASE_URL + '/test/current-week').then(
                (response) => {
                    commit('updateWeek', response.body);
                    resolve();
                },
                () => {
                    commit('updateWeek', 0);
                    reject();
                })
        })
    },

    socialAuth({dispatch, commit, getters, rootGetters}, sn) {
        let url = rootGetters['GET_URL_ROOT'] + sn;

        let screenX = (typeof window.screenX !== 'undefined') ? window.screenX : window.screenLeft;
        let screenY = (typeof window.screenY !== 'undefined') ? window.screenY : window.screenTop;
        let outerWidth = (typeof window.outerWidth !== 'undefined') ? window.outerWidth : document.body.clientWidth;
        let outerHeight = (typeof window.outerHeight !== 'undefined') ? window.outerHeight : (document.body.clientHeight - 22);
        let width = 800;
        let height = 600;
        let left = parseInt(screenX + ((outerWidth - width) / 2), 10);
        let top = parseInt(screenY + ((outerHeight - height) / 2.5), 10);
        let features = ( 'width=' + width + ',height=' + height + ',left=' + left + ',top=' + top );

        return new Promise((resolve, reject) => {
            let win = window.open(url, "_blank", features);

            let watch_timer = setInterval(() => {
                try {
                    if (win.closed) {
                        clearInterval(watch_timer);
                        dispatch('getUser').then(
                            () => {
                                resolve();
                            },
                            () => {
                                reject();
                            }
                        );
                    }
                } catch (e) {
                    reject();
                }
            }, 200);
        });
    },

    logout({dispatch, commit, getters, rootGetters}) {
        return new Promise((resolve, reject) => {
            Vue.http.get(rootGetters['GET_URL_ROOT'] + '/auth/logout').then(
                () => {
                    commit('clearAllData');
                    resolve();
                },
                () => {
                    commit('clearAllData');
                    resolve()
                })
        });
    },

    getRating({dispatch, commit, getters, rootGetters}, id) {
        return new Promise((resolve, reject) => {
            Vue.http.get(rootGetters['GET_URL_ROOT'] + BASE_URL + '/test-result?week=' + id+'&cache='+ Helpers.getRandomInt(0,1000)).then(
                (response) => {
					commit('updateRatingList', response.body);
                    commit('updateWinner', response.body);
                    resolve();
                },
                () => {
                    reject();
                })
        })
    },

    postVideo({dispatch, commit, getters, rootGetters},data) {
        return new Promise((resolve, reject) => {
            Vue.http.get(rootGetters['GET_URL_ROOT'] + BASE_URL + '/user-repeat/save?link='+ data.link+ '&date='+ data.date).then(
                (response) => {
                    resolve();
                },
                () => {
                    reject();
                })
        })
    },

    getUserRating({dispatch, commit, getters, rootGetters},) {
        console.log(getters['getUserId']);
        if (!getters['getUserId']) return;

        return new Promise((resolve, reject) => {
            Vue.http.get(rootGetters['GET_URL_ROOT'] + BASE_URL + '/test-result' +'?cache='+ Helpers.getRandomInt(0,1000), {
                params: {
                    // week: getters['getCurrentWeek'],
                    user_id: getters['getUserId']
                }
            }).then(
                (response) => {
                    commit('updateUserRatingList', response.body);
                    resolve();
                },
                () => {
                    commit('clearAllData');
                    reject();
                })
        })
    },

};

const getters = {
    getUserData: state => state.userData,
    isGuest: state => (typeof state.userData.id === 'undefined'),
    getCurrentWeek: state => state.currentWeek,
    getRatingList: state => state.ratingList,
    getWinner: state => state.winner,
    getUserId: (state, getters) => ('id' in getters.getUserData) ? getters.getUserData.id : '',
    getUserRatingList: state => state.userRatingList,
    getWinnerByWeek: (state, getters) => (id) => {
        return state.winners.find(item => Number(item.week) === Number(id));
    }
};

const mutations = {

    updateUserData(State, data) {
        State.userData = data;
    },

    clearAllData(State) {
        State.userData = {};
    },

    updateWeek(State, data) {
        State.currentWeek = data.weekNumber;
    },

    updateRatingList(State, data) {
        State.ratingList = data.items;
    },
    updateWinner(State, data) {
		// State.winner = data.winners[Object.keys(data.winners)[0]];
		State.winners = data.winners;
    },
    updateUserRatingList(State, data) {
        State.userRatingList = data.items;
    }
};

export default {
    namespaced: false,
    actions,
    state,
    getters,
    mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/user.js